export class ChartState {
  public isLoading: boolean;
  public hasError: boolean;
  public hasNoData: boolean;
  public isInit: boolean;

  constructor() {
    this.isLoading = false;
    this.hasError = false;
    this.hasNoData = false;
    this.isInit = false;
  }

  public setLoading() {
    this.isLoading = true;
    this.hasError = false;
    this.hasNoData = false;
    this.isInit = false;
  }

  public loadingSuccess() {
    this.isLoading = false;
    this.hasError = false;
    this.hasNoData = false;
    this.isInit = true;
  }

  public gotError() {
    this.isLoading = false;
    this.hasError = true;
    this.hasNoData = false;
  }

  public gotNoData() {
    this.isLoading = false;
    this.hasError = false;
    this.hasNoData = true;
  }

  public get isReady(): boolean {
    return this.isInit && !this.isLoading && !this.isInErrorState();
  }

  public isInErrorState(): boolean {
    return this.hasNoData || this.hasError;
  }
}
